import { FC, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import ROUTES from './routes';

const Public: FC = () => {
  return (
    <Suspense fallback={<div>loading</div>}>
      <Routes>
        {ROUTES.map(({ path, to, element, index }) => (
          <Route key={Math.random()} path={to ?? path} index={Boolean(index)} element={element} />
        ))}
        <Route path="*" element={<div>error</div>} />
      </Routes>
    </Suspense>
  );
};

export default Public;
